<header class="bg-white h-screen w-full">
  <div class="relative h-full w-full">
    <!-- navbar layer -->

    <app-organizer-navbar></app-organizer-navbar>
    <!-- text layer -->
    <div
      class="absolute bottom-0 left-0 w-full h-full flex items-center justify-center md:justify-end z-10"
    >
      <div
        class="flex flex-col items-center md:items-start justify-center md:justify-start md:mr-[10%] px-6 md:px-0"
      >
        <h1
          i18n="organizer.hero|Organize your sports headline@@organizer.hero.headline1"
          class="text-3xl md:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center md:text-left text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          Organize Your Sports
        </h1>

        <h1
          i18n="organizer.hero|Sessions inside LINE headline@@organizer.hero.headline2"
          class="text-3xl md:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center md:text-left text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
        >
          Sessions inside LINE
        </h1>
        @if (detectDomain()) {
          <h1
            i18n="organizer.hero|Extra headline line 3@@organizer.hero.headline3"
            class="text-3xl md:text-5xl font-bold text-white tracking-wide animate-fade-in-up text-center md:text-left text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
          >
            &nbsp;
          </h1>
        }
        <div class="flex flex-col md:flex-row items-center gap-4 mt-5">
          <button
            class="bg-white/40 text-sm text-white px-5 py-2.5 rounded-full font-light cursor-pointer flex items-center justify-center gap-2 animate-fade-in-up-delay-2"
          >
            <span><img src="check_white.svg" alt="Check White" class="w-6 h-6" /></span>
            <span
              i18n="organizer.hero|Collect payments badge@@organizer.hero.collectPayments"
              class="font-semibold text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
              >Collect Payments</span
            >
          </button>
          <button
            class="bg-white/40 text-sm text-white px-5 py-2.5 rounded-full font-light cursor-pointer flex items-center justify-center gap-2 animate-fade-in-up-delay-2"
          >
            <span><img src="check_white.svg" alt="Check White" class="w-6 h-6" /></span>
            <span
              i18n="organizer.hero|Reduce no-shows badge@@organizer.hero.reduceNoShows"
              class="font-semibold text-shadow-[0px_0px_10px_rgba(0,0,0,0.5)]"
              >Reduce No-Shows</span
            >
          </button>
        </div>
        <a
          class="w-full md:w-fit bg-white text-sm mt-10 text-main-blue-light px-5 py-2.5 rounded-full font-light cursor-pointer flex items-center justify-center gap-2 animate-fade-in-up-delay-2 hover:bg-main-yellow hover:text-white hover:border-0 transition-all duration-300 active:scale-95"
          href="https://lin.ee/qe4HGmS"
          target="_blank"
        >
          <span i18n="organizer.hero|Get in touch button@@organizer.hero.getInTouch"
            >Get In Touch</span
          >
          <span
            ><img src="open_in_new_blue.svg" alt="Open in new tab" class="w-4 h-4 inline-block"
          /></span>
        </a>
      </div>
    </div>
    <!-- background layer -->
    <div class="absolute bottom-0 left-0 w-full h-full z-0 overflow-hidden">
      <div class="relative w-full h-full">
        <img
          src="bg-organizer.jpg"
          alt="Organizer Hero Section Background"
          class="w-full h-full object-cover"
        />
        <div
          class="absolute inset-0 bg-gradient-to-l from-black/20 via-black/20 to-transparent [--tw-gradient-to-position:70%] md:block hidden"
        ></div>
        <div class="absolute inset-0 bg-black/35 md:hidden block"></div>
      </div>
    </div>
    <!-- dropdown layer -->
    <div class="absolute bottom-0 right-0 w-full flex items-center justify-center pb-10 z-20">
      <button class="cursor-pointer hover:scale-110 transition-all duration-300 active:scale-95">
        <img src="dropdown.svg" alt="Dropdown" class="md:w-10 md:h-10 w-8 h-8 animate-bounce" />
      </button>
    </div>
  </div>
</header>
